import { supabase } from '@/lib/supabase';

type TawkLoginData = { userId: string; hash: string; name?: string; email?: string };
type TawkCallback = (error?: unknown) => void;

export type TawkApi = {
  onLoad?: () => void;
  login?: (data: TawkLoginData, callback: TawkCallback) => void;
  logout?: (callback: TawkCallback) => void;
};

declare global {
  interface Window {
    Tawk_API?: TawkApi;
    Tawk_LoadStart?: Date;
  }
}

export const SCRIPT_SRC = 'https://embed.tawk.to/683c9e458cc43519129ba339/1ismckg9n';

let loggedInUserId: string | null = null;

export async function loginTawkChat() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session || session.user.id === loggedInUserId || !window.Tawk_API?.login) return;
  const { data: assurance } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
  if (assurance?.nextLevel === 'aal2' && assurance.currentLevel !== 'aal2') return;

  const res = await fetch('/api/v1/tawk/login', { headers: { Authorization: `Bearer ${session.access_token}` } });
  if (!res.ok) return;
  const data = (await res.json()) as TawkLoginData;
  window.Tawk_API.login(data, (error) => {
    if (!error) loggedInUserId = data.userId;
  });
}

export function logoutTawkChat() {
  loggedInUserId = null;
  const api = window.Tawk_API;
  if (api?.logout) {
    api.logout((error) => {
      if (error) clearTawkSession(true);
    });
  } else {
    clearTawkSession(!!api);
  }
}

function clearTawkSession(reload: boolean) {
  Object.keys(localStorage)
    .filter((key) => key.startsWith('twk_'))
    .forEach((key) => localStorage.removeItem(key));
  document.cookie
    .split('; ')
    .map((cookie) => cookie.split('=')[0])
    .filter((name) => name.startsWith('twk_') || name.startsWith('Tawk'))
    .forEach((name) => {
      document.cookie = `${name}=; Max-Age=0; path=/`;
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${location.hostname}`;
    });
  // A loaded widget keeps the previous session in memory
  if (reload) window.location.replace('/login');
}
